import { SelectedDeliveryChannel, Sla } from "./types";

export const getShippingTier = (sla: Sla): string => {
  const isPickup = sla.deliveryChannel === SelectedDeliveryChannel.PickupInPoint;

  if (isPickup) {
    const storeName = sla.pickupStoreInfo?.friendlyName?.trim();
    return storeName
      ? `retirada em loja: ${storeName}`
      : "retirada em loja";
  }

  return sla.name
    ? `receba em casa: ${sla.name.toLowerCase()}`
    : "receba em casa";
}


export const getDeliveryTime = (sla: Sla): number => {
  const estimate = sla.shippingEstimate;
  if (!estimate) return 0;

  const days = parseInt(estimate, 10);
  return isNaN(days) ? 0 : days;
}